import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Flex, Form, Input, InputNumber, List, Row, Select, Space} from "antd";
import {StyledPopUp} from "../../../../shared";
import {OnLocationConfirm, PricePopupProps} from "../../models";
import {useForm} from "antd/es/form/Form";
import {StyledCard} from "./PricePopup.styled";
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {useLocation} from "react-router-dom";

const PricePopup = ({open, onCansel, onConfirm}: PricePopupProps) => {
    const location = useLocation();
    const [form] = useForm();
    const [rentTypeData, setRentTypeData] = useState<any[]>([
        {
            label: 'ساعتی',
            value: 1,
        },
        {
            label: 'روزانه',
            value: 2,
        },
        {
            label: 'هفتگی',
            value: 3,
        }
        , {
            label: 'ماهانه',
            value: 4,
        }
        ,])
    const onFinish = (value: any) => {
        value?.prices?.map((i:any) => ({
            ...i,
            price:i?.price?.toString()
        }))
        onConfirm(value.prices.filter((item: any) => item.price !== null && item.price !== undefined && item.price !== '' && item.price !== ' '))
        onCansel()
    }
    // useEffect(() => {
    //     console.log(location.state?.stepOneForm)
    //     if (location.state?.stepTwoForm){
    //        form.setFieldsValue({prices: location.state?.stepTwoForm?.productPricings});
    //
    //     }
    // }, [location]);

    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px", fontWeight: 600 }}>تعیین قیمت ها</span>
                <span style={{ fontSize: "12px", color: "#818181ff", marginTop: "4px" }}>
💡 لطفاً قیمت اجاره محصول خود را برای بازه های زمانی مورد نظرتان وارد کنید. فقط گزینه‌هایی که مقدار دارند در آگهی نمایش داده خواهند شد.                </span>
            </div>
            }
            width={"100%"}
            footer={null}
            transitionName={''}

        >
            <Flex vertical gap={"small"} justify={"center"}>
                <Form onFieldsChange={(value: any) => {
                    let data = form.getFieldsValue()
                    setRentTypeData(rentTypeData.map((i: any) => ({
                        ...i,
                        disabled: data.prices.filter((x: any) => x?.priceType === i.value).length > 0
                    })))

                }} form={form} onFinish={onFinish} initialValues={{
                    prices: [
                        {
                            price: location.state?.stepTwoForm?.productPricings ?
                                location.state?.stepTwoForm?.productPricings[0]?.price : null,
                            pricingMethodId: 1,
                            label: 'ساعتی',
                        },
                        {
                            price: location.state?.stepTwoForm?.productPricings ?
                                location.state?.stepTwoForm?.productPricings[1]?.price : null,
                            pricingMethodId: 2,
                            label: 'روزانه',
                        },
                        {
                            price: location.state?.stepTwoForm?.productPricings ?
                                location.state?.stepTwoForm?.productPricings[2]?.price : null,
                            pricingMethodId: 3,
                            label: 'هفتگی',
                        },
                        {
                            price: location.state?.stepTwoForm?.productPricings ?
                                location.state?.stepTwoForm?.productPricings[3]?.price : null,
                            pricingMethodId: 4,
                            label: 'ماهانه',
                        },
                    ]
                }} layout={"inline"}>
                    <Card style={{width: "100%"}}>
                        <Form.List name="prices">
                            {(fields, {add, remove}) => (
                                <>
                                    {fields.map(({key, name, ...restField}) => (
                                        <Flex key={key} align={"center"} style={{marginBottom: '14px'}} gap={"small"}
                                              justify={"center"}>


                                            <Form.Item
                                                {...restField}
                                                name={[name, 'price']}
                                                label={form.getFieldValue(['prices', name, 'label'])}
                                            >
                                                <InputNumber<number>
                                                    placeholder={'قیمت به تومان'}
                                                    size={"large"}
                                                    style={{width: "100%"}}
                                                    formatter={(value) =>
                                                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                    }
                                                    parser={(value) =>
                                                        value?.replace(/\$\s?|(,*)/g, "") as unknown as number
                                                    }
                                                    suffix={"تومان"}
                                                />
                                            </Form.Item>

                                        </Flex>
                                    ))}


                                </>
                            )}
                        </Form.List>
                    </Card>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row justify={"center"}>
                            <Button size={"large"} type="primary" block htmlType={"submit"}
                            >انتخاب کنید</Button>
                        </Row>
                    </Col>

                </Form>
            </Flex>
        </StyledPopUp>
    );
};

export default PricePopup;